/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { useSelector } from 'react-redux';

import { COMMERCIAL_ACCOUNT_TYPE } from '../constants';
import { getCommTourList, getNonCommTourList } from '../utils/tourUtils';

export const useAccountType = () => {
    const { accountType } = useSelector((state) => state.timedEntry.accountType);
    const { tourList, isLoading } = useSelector((state) => state.timedEntry.tours);
    const [isCommAccount, setIsCommAccount] = React.useState(
        accountType === COMMERCIAL_ACCOUNT_TYPE
    );
    const [commTourList, setCommTourList] = React.useState(getCommTourList(tourList));
    const [nonCommTourList, setNonCommTourList] = React.useState(
        getNonCommTourList(tourList)
    );
    const [tourIdList, setTourIdList] = React.useState([]);

    React.useEffect(() => {
        const tourListToUse = isCommAccount ? commTourList : nonCommTourList;
        setTourIdList(tourListToUse.map((tour) => tour.tour_id));
    }, [commTourList, isCommAccount, nonCommTourList]);

    React.useEffect(() => {
        setCommTourList(getCommTourList(tourList));
        setNonCommTourList(getNonCommTourList(tourList));
    }, [isLoading, tourList]);

    React.useEffect(() => {
        setIsCommAccount(accountType === COMMERCIAL_ACCOUNT_TYPE);
    }, [accountType]);

    return {
        isCommAccount,
        accountType,
        commTourList,
        nonCommTourList,
        tourIdList,
    };
};
